// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/DueAmounts/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_DueAmounts(
  $where: payments_patient_payment_account_due_amounts_bool_exp!
  $treatment_id: numeric
  $has_treatment: Boolean!
) {
  payments_patient_payment_account_due_amounts(where: $where) {
    treatment_id
    payment_account_id
    insured_id
    total_due
    future_due
    due_now
    due_30_days
    due_60_days
    due_90_days
    due_120_days
    payment_account {
      id
      account_type
      person_payment_account {
        id
        payer_person {
          id
          first_name
          last_name
        }
      }
      insurance_payment_account {
        id
        insurance_company {
          id
          carrier_name
        }
      }
    }
  }
  vaxiom_txs(where: { id: { _eq: $treatment_id } })
    @include(if: $has_treatment) {
    id
    name
  }
}

`